import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

@Component({
  selector: 'mop-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  imports: [NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  type = input<'primary' | 'secondary' | 'tertiary'>('primary');
  text = input('');
  size = input<'lg' | 'md' | 'sm'>('md');

  protected computedGapClasses = computed(() => ({
    'gap-4': this.size() === 'lg',
    'gap-3': this.size() === 'md',
    'gap-2': this.size() === 'sm',
  }));
  protected computedSpinnerClasses = computed(() => ({
    'spinner-primary-color': this.type() === 'primary',
    'spinner-secondary-color': this.type() === 'secondary',
    'spinner-tertiary-color': this.type() === 'tertiary',
    'spinner-border-lg': this.size() === 'lg',
    'spinner-border-sm': this.size() === 'sm',
  }));
  protected computedTextClasses = computed(() => ({
    'text-primary-color': this.type() === 'primary',
    'text-secondary-color': this.type() === 'secondary',
    'text-tertiary-color': this.type() === 'tertiary',
    h1: this.size() === 'lg',
    h2: this.size() === 'md',
    h5: this.size() === 'sm',
  }));
}
